import React, { useEffect } from 'react';
import { createHashRouter, Navigate} from 'react-router-dom';

import EditProfileForm from '@/components/EditProfileForm';
import ProfileBilling from '@/components/Profile/ProfileBilling';
import ProfileInfo from '@/components/Profile/ProfileInfo';
import ProfileLayout from '@/components/Profile/ProfileLayout';
import ProfileMembership from '@/components/Profile/ProfileMembership/ProfileMembership';
import ProfileSettings from '@/components/Profile/ProfileSettings';
import { EditProfileProps } from '@/pages/EditProfile';
import ErrorPage from '@/pages/ErrorPage';

export const PROFILE_ROUTES = {
  ROOT: '/',
  PROFILE: 'profile',
  NOTIFICATION: 'notification',
  MEMBERSHIPS: 'memberships',
  BILLING: 'billing',
};

export const profilePageTitles = {
  [PROFILE_ROUTES.PROFILE]: 'Profile | EvoLux',
  [PROFILE_ROUTES.NOTIFICATION]: 'Profile Settings | EvoLux',
  [PROFILE_ROUTES.MEMBERSHIPS]: 'Membership | EvoLux',
  [PROFILE_ROUTES.BILLING]: 'Billing | EvoLux',
};

export const defaultProfilePageTitle = 'EvoLux';

export const useEditProfileRouter = ({
  user: { role, stripe_customer },
  user: user,
  timeZones,
  google_maps_api_key,
  newsletter_frequencies,
  stripeKey,
  stripeSecretKey,
}: EditProfileProps) => {
  const isUserRole = user.role === 'user';
  const userRoleRoutes = [
    {
      path: PROFILE_ROUTES.MEMBERSHIPS,
      element: isUserRole ? <ProfileMembership/> : <ErrorPage/>,
    },
  ];

  useEffect(() => {
    if (
      !isUserRole &&
      window.location.hash === "#/membership"
    ) {
      window.location.href = `${window.location.origin}/404`;
    }
  }, []);
  

  const router = createHashRouter([
    {
      element: <ProfileLayout isUserRole={isUserRole} />,
      children: [
        {
          element: <EditProfileForm />,
          children: [
            {
              path: PROFILE_ROUTES.ROOT,
              element: <Navigate to={PROFILE_ROUTES.PROFILE} replace />,
            },
            {
              path: PROFILE_ROUTES.PROFILE,
              element: (
                <ProfileInfo
                  isEditForm
                  role={role}
                  timeZones={timeZones}
                  google_maps_api_key={google_maps_api_key}
                />
              ),
            },
            {
              path: PROFILE_ROUTES.NOTIFICATION,
              element: <ProfileSettings frequencies={newsletter_frequencies} />,
            },
          ],
          
        },
        {
          path: "*",
          element: <ErrorPage/>
        },
        ...(isUserRole ? userRoleRoutes : []),
        {
          path: PROFILE_ROUTES.BILLING,
          element: (
            <ProfileBilling
              stripeKey={stripeKey}
              stripeSecretKey={stripeSecretKey}
              stripe_customer={stripe_customer}
              user={user}
            />
          ),
        },
      ],
    },
  ]);

  return { router };
};
